import { fetchAuthSession, signOut } from 'aws-amplify/auth'
import { setContext } from '@apollo/client/link/context'

/* v6 fetchAuthSession also fetches identity-pool credentials, which can fail transiently
   (network, throttling) on any request — only a definitive auth failure may end the
   session, otherwise a blip would revoke the shared .hssoft.com login. */
const isAuthFailure = error => error?.name === 'NotAuthorizedException' || error?.name === 'UserUnauthorizedException' || error?.name === 'UserUnAuthenticatedException'

export const withAuth = setContext(async (_, { headers, clientAwareness = {} }) => {
	let token
	try {
		token = (await fetchAuthSession()).tokens?.idToken?.toString()
	} catch (error) {
		if (isAuthFailure(error)) {
			await signOut()
		}
		throw error
	}
	if (!token) {
		// v6: fetchAuthSession resolves with empty tokens instead of throwing when
		// the session is gone — treat it the same as an expired session.
		await signOut()
		throw new Error('No valid auth session')
	}
	return {
		headers: {
			...headers,
			'apollographql-client-name': clientAwareness.name,
			'apollographql-client-version': clientAwareness.version,
			'request-time': new Date().toISOString(),
			'Authorization': token
		}
	}
})
